import { Injectable, signal } from '@angular/core';
import { AppSetupApi } from 'api/app-setup/app-setup-api.js';
import { ImageGalleryApi } from 'api/image-gallery/image-gallery-api.js';

@Injectable({
	providedIn: 'root'
})
export class AppDataService {
	public readonly appContext = signal<AppSetupApi.IAppContext | undefined>(undefined);
	public readonly imageGalleries = signal<ImageGalleryApi.IImageGalleries | undefined>(undefined);
}
